module.exports = __webpack_public_path__ + "img/invoice.cedd7bf5.svg";